import React from 'react'
import axios from 'axios'
import _ from 'underscore'
import { LoaderCircle } from 'lucide-react'
import EmailComposer from './composer'
import store from '../../state/store'

class Emailer extends React.Component {

  constructor(props) {
    super(props)
    
    this.state = {
      email: props.email,
      templates: props.templates,
      template_name: props.template_name,
      loading: _.isEmpty(props.email)
    }
  }

  componentDidMount() {
    if (_.isEmpty(this.state.email)) {
      this.fetchEmailContent()
    }
  }

  componentWillUnmount() {
    store.emit('ui:mailer:change', {
      email: this.state.email,
      templates: this.state.templates,
      template_name: this.state.template_name
    })
  }

  onEmailChange = (email) => {
    this.setState({
      email: email
    })
  }

  onTemplateChange = (template_name) => {
    this.fetchEmailContent({template_name: template_name})
  }

  fetchEmailContent = (params = {}) => {
    const getParams = {
      related_to_type: this.props.related_to_type,
      related_to_id: this.props.related_to_id,
      template_name: params.template_name || 'draft'
    }

    axios.get("/api/sales/emails/new", {params: getParams})
    .then((response) => {
      this.setState({
        email: response.data.email,
        templates: response.data.templates,
        template_name: getParams.template_name
      })
    })
    .catch((error) => {
      handleError(error)
    })
    .then(() => {
      this.setState({loading: false})
    })
  }

  onConfirm = () => {
    const params = {
      related_to_type: this.props.related_to_type,
      related_to_id: this.props.related_to_id,
      email_sender_id: this.state.email.sender_id,
      email_to: this.state.email.to,
      email_cc: this.state.email.cc,
      email_bcc: this.state.email.bcc,
      email_subject: this.state.email.subject,
      email_content: this.state.email.content
    }

    axios.post("/api/sales/emails", params)
    .then((response) => {
      showMessage('Email sent.')
      this.props.onClose()
    })
    .catch((error) => {
      handleError(error)
    })
  }

  render() {
    if (this.state.loading) {
      return (
        <section className="flex justify-center p-10">
          <LoaderCircle className="size-8 animate-spin text-muted-foreground"/>
        </section>
      )
    }

    return (
      <div className="mx-auto p-3 bg-[repeating-linear-gradient(135deg,#F29B91_0px,#F09290_30px,transparent_30px,transparent_50px,#83B3DB_50px,#84ADCB_80px,transparent_80px,transparent_100px)]">
        <div className="size-full bg-background p-6">
          {/* Heading lives inside the airmail frame — a Modal title above it
              breaks the envelope illusion. */}
          <h2 className="mb-4 font-heading text-base font-medium">Send Email</h2>
          <EmailComposer
            key={this.state.template_name}
            email={this.state.email}
            templates={this.state.templates}
            onChange={this.onEmailChange}
            onSend={this.onConfirm}
            onTemplateChange={this.onTemplateChange}
          />
        </div>
      </div>
    )
  }
}

export default Emailer
